// extracted by mini-css-extract-plugin
export default {"mCard":"js-z","image":"ks-z","imageNoBackground":"ls-z","fullWidth":"ms-z"};